import React from 'react';
import ReactDOM from 'react-dom/client';
// import smartlookClient from 'smartlook-client';
import mapboxgl from 'mapbox-gl';
import { startAnalyticsConsentSync } from 'utils/analyticsConsent';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import AppProviders from 'AppProviders';

// if (process.env.REACT_APP_ENV === 'prod' && process.env.REACT_APP_SMARTLOOK_PROJECT_KEY) {
//   smartlookClient.init(process.env.REACT_APP_SMARTLOOK_PROJECT_KEY || '');
// }

// Amplitude, Datadog RUM and Pendo are "statistics" cookies: nothing is started
// here. The sync starts them only once Cookiebot reports statistics consent, and
// tears them down again if it is withdrawn.
if (typeof window !== 'undefined') {
  startAnalyticsConsentSync();
}

const mapboxAccessToken = process.env.REACT_APP_MAPBOX_API_KEY;
if (!mapboxAccessToken || !mapboxAccessToken.trim()) {
  throw new Error(
    'Missing REACT_APP_MAPBOX_API_KEY. Configure a valid Mapbox access token before starting the app.'
  );
}
mapboxgl.accessToken = mapboxAccessToken;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
